import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { ConcessaoTipo } from '@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-tipo.enum';
import { ConcessaoVeiculoSituacao } from '@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-veiculo-situacao.enum';
import { ConcessaoVeiculoDTO } from 'app/model/dtos/mob/concessao-veiculo.dto';
import { ConcessaoVeiculoSearch } from 'app/services/mob/concessao-veiculo.search';
import { ConcessaoVeiculoService } from 'app/services/mob/concessao-veiculo.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { DialogFactory } from 'sol-tools-ts/dist';

@Component({
  selector: 'dropdown-placa-rural',
  templateUrl: './dropdown-placa-rural.component.html',
  styleUrls: ['./dropdown-placa-rural.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DropdownPlacaRuralComponent implements OnInit {

  veiculos: ConcessaoVeiculoDTO[];
  formGroup: FormGroup;
  cdPessoa: number;
  aviso: string = 'O concessionário deve ser selecionado';

  constructor(
    private _controlContainer: ControlContainer,
    private _dialogFactory: DialogFactory,
    private _concessaoVeiculoService: ConcessaoVeiculoService

  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.formGroup.get('cdPessoa').valueChanges.subscribe(_ => {
      this.cdPessoa = this.formGroup.get('cdPessoa').value;
      this.aviso = '';
      this.load();
    })
   }

  async load(){
    try{
      this.veiculos = await this._concessaoVeiculoService.findVeiculos(new ConcessaoVeiculoSearch({
        cdConcessionario: this.cdPessoa, 
        tpConcessao: ConcessaoTipo.COLETIVO_RURAL, 
        stConcessaoVeiculo: ConcessaoVeiculoSituacao.VINCULADO
      }));
      this.setPlaca();
    }catch(error){
      this._dialogFactory.snack(error.detail || error.message, 'OK', DialogFactory.SNACK_WARNING);
    }
  }

  setPlaca() {
    if(this.veiculos.length == 1) {
      this.formGroup.get('cdVeiculo').setValue(this.veiculos[0].cdVeiculo);
    }
  }

  selecionarVeiculo(cdVeiculo:number){
    this.formGroup.get('cdVeiculo').setValue(cdVeiculo);
  }
}
